(function(){
if (window.__abnReco) return;
window.__abnReco = true;

function echec(b, texte, carte){
  b.disabled = false; b.textContent = texte;
  var n = carte && carte.querySelector('[data-abn-reco-note]');
  if (n) { n.textContent = (carte.getAttribute('data-abn-reco-err') || 'That kit could not be added. Open its page to pick your options.'); n.hidden = false; }
}

document.addEventListener('click', function(e){
  var b = e.target.closest && e.target.closest('[data-abn-reco-add]');
  if (!b) return;
  e.preventDefault();
  var id = b.getAttribute('data-abn-reco-add');
  if (!id || b.disabled) return;
  var texte = b.textContent;
  var carte = b.closest('[data-abn-reco]');
  b.disabled = true; b.textContent = (carte && carte.getAttribute('data-abn-reco-adding')) || 'Adding...';

  // Dans le tiroir, on reste sur place : Shopify rend la section et le tiroir se rafraichit.
  // Sur /cart, on recharge la page du panier.
  var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var tiroir = b.closest('cart-drawer');
  var corps = {items: [{id: Number(id), quantity: 1}]};
  if (tiroir) corps.sections = 'cart-drawer,cart-icon-bubble';

  fetch(racine + 'cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
    body: JSON.stringify(corps)
  }).then(function(r){
    if (!r.ok) throw new Error('http ' + r.status);
    return r.json();
  }).then(function(etat){
    if (tiroir && etat && etat.sections && etat.sections['cart-drawer'] && typeof tiroir.renderContents === 'function') {
      tiroir.renderContents(etat);
      return;
    }
    window.location.assign(racine + 'cart');
  }).catch(function(){
    echec(b, texte, carte);
  });
});
    })();
